import { AuthClient } from "../data/auth-client";

async function UpdatePassword(token, password) {
  try {
    const authClient = new AuthClient();

    const response = await authClient.resetPassword(token, password);

    return response;
  } catch (err) {
    console.error("Update User error", err);
    throw err;
  }
}

export default UpdatePassword;
